'use strict';

const storeLocator = require('base/storeLocator/storeLocator');
const utils = require('../utils/utils');

/**
 * remove the store selector modal when a store is selected out of results
 */
function closeChangeStoreModal() {
    if ($('#changeStoreModal').length > 0) {
        $('#changeStoreModal').modal('hide');
        $('#changeStoreModal').remove();
    }
}

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($('#changeStoreModal').length > 0) {
        $('#changeStoreModal').remove();
    }
    var htmlString = `
        <!-- Modal -->
        <div class="modal" id="changeStoreModal" role="dialog">
            <div class="modal-dialog change-store-dialog modal-lg modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header justify-content-end">
                        <button type="button" class="close pull-right" data-dismiss="modal" title="${$('.change-store-container').data('modal-close-text')}">&times;
                        </button>
                    </div>
                    <div class="modal-body"></div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
        `;

    $('body').append(htmlString);
    $('#changeStoreModal').modal('show');
}

/**
 * Replaces the content in the modal window with find stores components and the result store list.
 * @param {string} actionUrl - URL endpoint
 * @param {number} selectedPostalCode - The postal code to search for inventory
 * @param {number} selectedRadius - The radius to search for inventory
 */
function fillModalElement(actionUrl, selectedPostalCode, selectedRadius) {
    var requestData = {};
    if (selectedRadius) requestData.radius = selectedRadius;
    if (selectedPostalCode) requestData.postalCode = selectedPostalCode;
    if (!actionUrl) return;

    $('#changeStoreModal').spinner().start();
    $.ajax({
        url: actionUrl,
        method: 'GET',
        success: function (response) {
            $('#changeStoreModal .modal-body').empty();
            $('#changeStoreModal .modal-body').html(response.storesResultsHtml);
            storeLocator.search();
            storeLocator.changeRadius();
            storeLocator.selectStore();
            storeLocator.updateSelectStoreButton();

            if (selectedRadius) {
                $('#radius').val(selectedRadius);
            }

            if (selectedPostalCode) {
                $('#store-postal-code').val(selectedPostalCode);
            }

            if (!$('.results').data('has-results')) {
                $('.store-locator-no-results').show();
            }

            $('#changeStoreModal').modal('show');
        },
        complete: function () {
            $('#changeStoreModal').spinner().stop();
        }
    });
}

/**
 * once a store is selected, update shop by store refinement, and auto-select refinement
 * @param {Object} data - set store response
 */
function filterByStore(data) {
    if (!data.storeId || !data.storeName) return;

    $.spinner().start();
    var $storeRefineButton = $('.store-refine-button');
    var refineUrl = $storeRefineButton.data('href');
    if (refineUrl) {
        refineUrl = utils.removeParamFromURL(refineUrl, 'storeId');
        refineUrl = utils.appendToUrl(refineUrl, { storeId: data.storeId });
        $storeRefineButton.data('href', refineUrl);
    }
    if ($('.store-refine-icon').length) {
        $('.store-refine-icon').removeClass('fa-square-o').addClass('fa-check-square');
    }
    $('.store-refine-name').addClass('selected').empty().html(data.storeName);
    $storeRefineButton.removeClass('disabled d-none').click();
    $.spinner().stop();
}

module.exports = {
    changeStore: function () {
        $('body').on('click', '.store-refinement-change-store', (function () {
            getModalHtmlElement();
            fillModalElement($(this).data('action-url'), $(this).data('postal'), $(this).data('radius'));
        }));
    },

    selectStore: storeLocator.selectStore,

    storeSelection: function () {
        $('body').on('store:selected', function (e, data) {
            closeChangeStoreModal();

            var url = $('.change-store-container').data('set-store-url');
            if (url && data.storeID) {
                url = utils.appendToUrl(url, { storeId: data.storeID });
                $.spinner().start();
                $.ajax({
                    url: url,
                    method: 'GET',
                    success: function (response) {
                        filterByStore(response);
                    },
                    complete: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    }
};
